const steps = [
  {
    icon: 'ri-radar-line',
    title: '捕捉苗头',
    desc: '从公开讨论与多方爆料中发现潜在热点，判断其传播潜力与是否需要长期追踪。',
  },
  {
    icon: 'ri-focus-3-line',
    title: '核验信源',
    desc: '交叉比对媒体通稿、当事人回应与权威渠道，剔除未经证实的二手信息与情绪化表达。',
  },
  {
    icon: 'ri-node-tree',
    title: '拉通时间线',
    desc: '把事件拆解为“爆发—发酵—关键节点—回应—后续”等节点，串成清晰可读的时间轴。',
  },
  {
    icon: 'ri-loop-left-line',
    title: '持续追踪更新',
    desc: '事件未尘埃落定前持续跟进，出现新进展及时补充节点，保证追更不中断。',
  },
];

export default function MethodSection() {
  return (
    <section id="method" className="scroll-mt-24 border-y border-background-300/60 bg-accent-100/40 py-12 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid gap-8 lg:grid-cols-2 lg:items-center">
          <div>
            <span className="inline-flex items-center gap-1.5 text-xs font-semibold tracking-wide text-accent-700">
              <i className="ri-tools-line" /> 我们的工作方式
            </span>
            <h2 className="mt-2 font-heading text-2xl font-semibold leading-snug text-foreground-950 md:text-3xl">
              一条吃瓜时间轴
              <br className="hidden lg:block" /> 是怎么被整理出来的
            </h2>
            <p className="mt-4 max-w-lg text-sm leading-relaxed text-foreground-600">
              吃瓜容易，追清楚不容易。瓜迹的编辑团队每天跟踪热点动态，用统一的四步流程把散落的信息落成清晰节点，让每一件热事的经过与进展都能被快速读懂。
            </p>
            <a
              href="/about"
              className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-accent-300 bg-background-50 px-5 py-2.5 text-sm font-medium text-accent-800 transition-colors hover:bg-accent-100"
            >
              了解瓜迹的整理原则 <i className="ri-arrow-right-line" />
            </a>
          </div>

          <ol className="space-y-4">
            {steps.map((s, i) => (
              <li key={s.title} className="group flex items-start gap-4 rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-accent-200">
                <span className="relative flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-accent-500 text-foreground-950">
                  <i className={`text-xl ${s.icon}`} />
                  <span className="absolute -right-1.5 -top-1.5 flex h-5 w-5 items-center justify-center rounded-full border border-background-50 bg-foreground-950 text-[10px] font-bold text-background-50 tabular-nums">
                    {i + 1}
                  </span>
                </span>
                <div>
                  <h3 className="text-base font-semibold text-foreground-950">{s.title}</h3>
                  <p className="mt-1 text-sm leading-relaxed text-foreground-600">{s.desc}</p>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}